module.exports = __webpack_public_path__ + "static/media/Digitaltool.f15fd348.jpg";